(function(){
  "use strict";

  angular.module("modules.price", []);

})();